module.exports = __webpack_public_path__ + "img/team.81d1ae85.png";